import React from "react";

import { useGetApplicationQuery } from "../api";
import * as urls from "../urls";
import { VerticalBreadcrumbs } from "Common/Breadcrumbs/VerticalBreadcrumbs";
import SplitPage from "Common/SplitPage";

import makeBem from "Utils/makeBem";

const bem = makeBem("BORPage");

const crumbs = [
  {
    sectionName: "companyInformation",
    title: "Company Information",
    description: "Confirm your company information",
    link: `${urls.baseURL}${urls.companyInformationURL}`,
    status: "incomplete",
  },

  {
    sectionName: "currentPlan",
    title: "Insurance Plans",
    description: "Tell us your carrier name and group number",
    link: `${urls.baseURL}${urls.currentPlanURL}`,
    status: "incomplete",
  },

  {
    sectionName: "confirmation",
    title: "Review and Sign",
    description: "Approve the move",
    link: `${urls.baseURL}${urls.confirmationURL}`,
    status: "incomplete",
  },

  {
    sectionName: "contributions",
    title: "Contribution",
    description: "Tell us the amount you contribute to health insurance",
    link: `${urls.baseURL}${urls.contributionsURL}`,
    status: "incomplete",
  },

  {
    sectionName: "fileUpload",
    title: "File Upload",
    description: "Upload supporting documents",
    link: `${urls.baseURL}${urls.fileUploadURL}`,
    status: "incomplete",
  },
];

const getBreadcrumbs = (borApplication) => {
  crumbs.forEach((crumb) => {
    const appSectionStatus = borApplication?.applicationStatus.sections[crumb.sectionName];
    let status = appSectionStatus ? "complete" : "incomplete";
    if (window.location.pathname.includes(crumb.link)) {
      status = "current";
    }
    crumb.status = status;
  });
  return crumbs;
};

const BORPage = ({ children }) => {
  const { data: borApplication, error: _error } = useGetApplicationQuery();
  const crumbs = getBreadcrumbs(borApplication);

  return (
    <SplitPage.Wrapper mx={0}>
      <SplitPage.Main>{children}</SplitPage.Main>
      <SplitPage.Aside>
        <div className={bem("wizardPlacement")}>
          <VerticalBreadcrumbs crumbs={crumbs} />
        </div>
      </SplitPage.Aside>
    </SplitPage.Wrapper>
  );
};

export default BORPage;
